import React from "react";
import { useLang } from "../../i18n";
import { Reveal } from "../motion";
import { LeafSprig, HerbSprig } from "../Botanicals";

const Manifesto = () => {
  const { t } = useLang();
  const chapters = t("manifesto.chapters");

  return (
    <section id="approche" data-testid="manifesto" className="relative overflow-hidden max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
      <LeafSprig className="pointer-events-none absolute -top-2 right-2 w-36 lg:w-44 text-primary/10 animate-sway hidden md:block" />
      <HerbSprig className="pointer-events-none absolute bottom-10 left-1 w-14 text-coral/30 animate-sway hidden lg:block" />
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-foreground">
              {t("manifesto.title")}
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8 lg:pl-12">
          <div className="divide-y divide-border">
            {chapters.map((c, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="py-10 grid md:grid-cols-12 gap-6 items-start group">
                  <div className="md:col-span-2">
                    <span className="font-serif text-6xl md:text-7xl text-secondary leading-none group-hover:text-primary transition-colors duration-500">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="md:col-span-10">
                    <h3 className="font-serif text-2xl md:text-3xl text-foreground mb-3">{c.t}</h3>
                    <p className="text-foreground/65 leading-relaxed max-w-xl font-light">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
